/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_TrackInputs */

const en_compare_track = /** @type {(inputs: Compare_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare Track`)
};

const fr_compare_track = /** @type {(inputs: Compare_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piste de comparaison`)
};

const de_compare_track = /** @type {(inputs: Compare_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergleichen Sie die Strecke`)
};

const it_compare_track = /** @type {(inputs: Compare_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confronta traccia`)
};

const ru_compare_track = /** @type {(inputs: Compare_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сравнить трек`)
};

const es_compare_track = /** @type {(inputs: Compare_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparar pista`)
};

const zh_cn2_compare_track = /** @type {(inputs: Compare_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比较轨道`)
};

const ja_compare_track = /** @type {(inputs: Compare_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トラックを比較`)
};

const hi_compare_track = /** @type {(inputs: Compare_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ट्रैक की तुलना करें`)
};

const pt_pt2_compare_track = /** @type {(inputs: Compare_TrackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparar faixa`)
};

/**
* | output |
* | --- |
* | "Compare Track" |
*
* @param {Compare_TrackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_track = /** @type {((inputs?: Compare_TrackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_TrackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_track(inputs)
	if (locale === "de") return de_compare_track(inputs)
	if (locale === "it") return it_compare_track(inputs)
	if (locale === "ru") return ru_compare_track(inputs)
	if (locale === "es") return es_compare_track(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_track(inputs)
	if (locale === "ja") return ja_compare_track(inputs)
	if (locale === "hi") return hi_compare_track(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_track(inputs)
	return en_compare_track(inputs)
});